export default __webpack_public_path__ + "static/media/elo-store.11232030.svg";